import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { State } from "../models/state"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class StateService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'state/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllStates(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<State>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllStates?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  getAllStatesbyRegion(Region_Id?: string): Observable<Array<State>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllStatesbyRegion/' + (Region_Id ? Region_Id : '')  ).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewState(StateID?: string): Observable<Array<State>> {
    return this.httpService.get(this.apiEndpoint + 'viewState/' + (StateID ? StateID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveState(locations: State): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveState/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteState(StateID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteState/' + (StateID ? StateID : '00000000-0000-0000-0000-000000000000'), StateID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(StateId?: string,Code?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?&StateId=' + (StateId ? StateId : '00000000-0000-0000-0000-000000000000')+'&Code=' + (Code ? Code : '')).pipe(map((result: any) => {
        return result; 
    }));
  }
  
  checkEmail(Emailid?: string,StateId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&StateId=' + (StateId ? StateId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
